// extracted by mini-css-extract-plugin
export default {"cookiesInfo":"SelectionInfo_cookiesInfo__Bas-P","circle":"SelectionInfo_circle__XxYiE","circleNavigation":"SelectionInfo_circleNavigation__iqo92"};